module.exports = __webpack_public_path__ + "static/img/background.3a4d212c.svg";